import { Routes } from '@angular/router';

import { UrlService, setupFeatureFlagsForModule } from '@core/shared/util';
import { provideFavoritesDataAccess } from '@mp/content-manager/favorites/data-access';
import { provideFacetSelectionService } from '@mp/shared/facets/util';

import { ArtikelsucheFilterFacade } from './artikelsuche-filter.facade';
import { ArtikelsucheShellComponent } from './artikelsuche-shell.component';

const baseTitle = 'Artikelsuche';

export const ARTIKELSUCHE_ROUTES: Routes = [
  {
    path: '',
    component: ArtikelsucheShellComponent,
    data: setupFeatureFlagsForModule({ customHeader: true }),
    providers: [provideFacetSelectionService(), provideFavoritesDataAccess(), ArtikelsucheFilterFacade, UrlService],
    children: [
      {
        path: 'exports',
        loadChildren: async () => (await import('@mp/content-manager/exports/feature')).EXPORTS_ROUTES,
        title: `${baseTitle} | Exporthistorie`,
      },
      {
        path: 'favoriten',
        loadChildren: async () => (await import('@mp/content-manager/favorites/feature')).FAVORITE_ROUTES,
        title: `${baseTitle} | Favoriten`,
      },
      {
        path: 'start',
        loadComponent: async () => (await import('./start/start.component')).StartComponent,
        title: baseTitle,
      },
      {
        path: 'list',
        loadComponent: async () => (await import('./artikelsuche/artikelsuche.component')).ArtikelsucheComponent,
        title: `${baseTitle} | Ergebnis`,
      },
      {
        path: 'not-found',
        loadComponent: async () => (await import('./not-found/artikel-not-found.component')).ArtikelNotFoundComponent,
        title: `${baseTitle} | Artikel nicht gefunden`,
      },
      {
        path: '',
        redirectTo: 'start',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: async () => (await import('./detail/article-details.routes')).ARTICLE_DETAILS_ROUTES,
        title: `${baseTitle} | Artikeldetails`,
      },
    ],
  },
];
